import React from 'react';
import { makeData, Logo, Tips } from '../Utility/utility.js';
import matchSorter from 'match-sorter';

// Import React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import './NonRosteredTable.css';

export class NonRosteredTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: makeData()
    };
  }
  columns = [
    {
      Header: 'Player',
      id: 'player',
      accessor: d => [d.first_name, ' ', d.last_name],
      filterMethod: (filter, row) => {
        return (
          row[filter.id][0].toLowerCase().includes(filter.value) ||
          row[filter.id][2].toLowerCase().includes(filter.value)
        );
      },
      minWidth: 140
    },
    {
      Header: 'Age',
      accessor: 'age',
      id: 'age',
      width: 45
    },
    {
      Header: 'POS',
      id: 'position',
      accessor: d => d.depth_chart_position,
      width: 45
    },
    {
      Header: 'Hand',
      id: 'handedness',
      accessor: 'handedness',
      width: 40
    },
    {
      Header: 'HENRI',
      id: 'henri',
      accessor: d => (d.henri ? '$' + d.henri.toLocaleString() : null)
    }
  ];
  handleChange(e, id) {
    this.refs.NonRostered.filterColumn(this.columns[id], e.target.value);
  }

  render() {
    const { data } = this.state;
    return (
      <div className="contract-table-body">
        <div style={{ background: '#133b56' }}>
          <input
            onChange={e => this.handleChange(e, 0)}
            placeholder={'Search Players'}
          />
        </div>
        <ReactTable
          className={'NonRostered'}
          ref="NonRostered"
          toggleActive={this.props.toggleActive}
          data={this.props.data}
          style={{ overflow: 'auto' }}
          showPagination={this.props.showPagination}
          defaultSorted={[{ id: 'henri', desc: true }]}
          defaultPageSize={this.props.data.length}
          defaultFilterMethod={(filter, row) =>
            String(row[filter.id]) === filter.value
          }
          getTrProps={(state, rowInfo, column, instance, data) => ({
            onClick: () => {
              console.log(instance.props.data[rowInfo.index].playerid);
            }
          })}
          columns={this.columns}
          resizable={false}
          className="-striped -highlight NonRostered"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/NonRosteredTable.js